module.exports = __webpack_public_path__ + "img/full6-min.75df5ae9.png";